import hash from 'object-hash';

export class SearchCache {
	constructor (throttleTime = 30000) {

		/**
		 * @type {number}
		 */
		this.throttleTime = throttleTime;

		/**
		 * @type {Map<string, import('custom-extensions/search/lib/api/types').SearchCacheRecord>}
		 */
		this.store = new Map();
	}

	/**
	 * @param {import('custom-extensions/search/lib/api/types').SearchCacheKey} obj
	 */
	generateKey (obj) {
		return hash(obj);
	}

	/**
	 * @param {import('custom-extensions/search/lib/api/types').SearchCacheKey} obj
	 */
	access (obj) {
		const key = this.generateKey(obj);
		const record = this.store.get(key);

		if (record) {
			const now = Date.now();

			if (record.timestamp - now > this.throttleTime) {
				this.remove(obj);
				return null;
			}

			return record.data;
		}

		return null;
	}

	/**
	 * @param {import('custom-extensions/search/lib/api/types').SearchCacheKey} obj
	 * @param {import('custom-extensions/search/lib/api/types').SearchCacheRecordData} value
	 */
	insert (obj, value) {
		const key = this.generateKey(obj);

		/**
		 * @type {import('custom-extensions/search/lib/api/types').SearchCacheRecord}
		 */
		const record = {
			data: value,
			timestamp: Date.now()
		};

		this.store.set(key, record);

		return true;
	}

	/**
	 * @param {import('custom-extensions/search/lib/api/types').SearchCacheKey} obj
	 */
	remove (obj) {
		const key = this.generateKey(obj);

		return this.store.delete(key);
	}

	purge () {
		this.store.clear();

		return true;
	}
};
